import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import { SimulationLane } from "../models/SimulationLane";
import {
  CreateSimulationWay,
  SimulationResponse,
  SimulationWay,
  UpdateSimulationWay,
} from "../models/SimulationWay";

const prefix = "/simulation-ways";

export const SimulationWayApi = {
  get: async (hlaWayId: string) =>
    await optionalAuthAxios().get<SimulationResponse>(
      `${prefix}/${hlaWayId}/simulation`,
    ),
  update: async (simulationWayId: string, body: UpdateSimulationWay) => {
    return await jwtAuthAxios().put<{
      simulationWay: SimulationWay;
      simulationLanes: SimulationLane[];
    }>(`${prefix}/${simulationWayId}`, body);
  },
  createSimulated: async (body: CreateSimulationWay) => {
    return await jwtAuthAxios().post<SimulationResponse>(`${prefix}`, body);
  },
  deleteSimulation: async (simulationWayId: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${simulationWayId}`);
  },
  listHlaWayIdsBySurvey: async (surveyId: string) => {
    return await optionalAuthAxios().get<string[]>(
      `${prefix}/survey/${surveyId}/hla-way-ids`,
    );
  },
};
